<script >
import CookieNotice from "@/components/Notices/CookieNotice.vue";
import UIkit from "uikit";
import PrivacyNotice from "@/components/Notices/PrivacyNotice.vue";
import DataProtectionNotice from "@/components/Notices/DataProtectionNotice.vue";
import Cookies from 'js-cookie';

/*  window.onbeforeunload = function () {
    if (modal.isOpen()) {
      return "Modal is";
    }
  }*/

export default {
  name: "cookieModal",
  components: {
    PrivacyNotice, CookieNotice, DataProtectionNotice
  },
  methods: {
    makeModalTrue: function () {
      localStorage.setItem("modalSeen", "true")
    },
    showModalAgain: function () {
      UIkit.modal('#myModal').show();
    }
  },
  mounted() {

    if(localStorage.getItem('modalSeen') === null){
      localStorage.setItem('modalSeen', "false");
    }

    if(localStorage.getItem('modalSeen') !== "true"){
      UIkit.modal('#myModal').show();

      //alert(localStorage.setItem( ))
    }

  }
}



/*
window.onload = function () {
  var modal = document.getElementById("modal");
  document.getElementById("info").onclick = function (){
    UIkit.util.on('#info', 'click', function (e) {
      e.preventDefault();
      e.target.blur();
      /!*UIkit.modal.alert('UIkit alert!').then(function () {
        console.log('Alert closed.')
      });*!/
    });
  }
  document.getElementById("data").onclick = function (){
    UIkit.modal('#myModal').show();
  }
  document.getElementById("privacy").onclick = function (){
    UIkit.modal('#myModal').show();
  }
}
*/
/*const modal = UIkit.modal('#myModal');




  if (typeof Cookies.get(cookieName) !== 'undefined') {
    $('.uk-modal-container, .uk-modal-dialog, .uk-modal-body').remove();
  } else
    $('.uk-modal-close-default, .uk-modal-close').on('click', function (){
      Cookies.set(cookieName, 'ok', { expires: 1});
    })*/
/*function getCookie(cookieName) {
  //return localStorage.getItem(cookieName);
  if(typeof localStorage != "undefined")
  {
    return localStorage.getItem(cookieName);
  }
  else
  {
    var cookies = document.cookie.indexOf(cookies + "=");
    if (document.cookie.length > 0)
    {
      if (cookies !== -1)
      {
        return getCookieSubstring(cookies, cookieName);
      }
    }
    return "";
  }
}

function setCookie(cookieName, value, expiredays) {
  //return localStorage.setItem(cookieName, value)
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  if(typeof localStorage != "undefined")
  {
    alert("This place has local storage!");
    localStorage.setItem(cookieName, value);
  }
  else
  {
    alert("No local storage here");
    document.cookie = cookieName + "=" + escape(value) +
        ((expiredays === null) ? "" : ";expires=" + exdate.toUTCString());
  }
}*/
/*UIkit.util.on('#myModal', 'click', function (e) {
  e.preventDefault();
  e.target.blur();
  UIkit.modal.confirm('UIkit confirm!').then(function () {
    console.log('Confirmed.')
  }, function () {
    console.log('Rejected.')
  });
});*/
/*UIkit.ready(function ()
    {
      var theCookie = Cookies.get('modal_cookie', {secure: true});
      let theModal;
      theModal = UIkit.modal('#myModal');
      UIkit.$('#myModal').on({
        'hide.uk.modal' : function() {
          //set cookie
          let Cookies;
          Cookies.set('modal_cookie', 'hide', { secure: true, expires: 1});
        }
      });
      document.getElementById('the-button').addEventListener('click', function(e, btn){
        theModal.hide();
      })
      setTimeout(function() {
        if (theCookie === 'hide') {
          //do nothing
        } else {
          //show modal
          theModal.show();
        }
      })
    }

)*/
/*
  $(window).on('load', function () {
  $('#myModal').modal('show');
})
;
*/
/*$(document).ready(function(){
  $('#myModal').modal('show');
  document.cookie = "modal_shown=seen"
  alert(document.cookie);
})*/

</script>

<template>
  <div class="uk-padding modal" id="modal" >
<!--    <a class="uk-button uk-button-default" href="#myModal"  uk-toggle >Open</a>-->
    <div class="uk-container uk-container-small " >
      <div class="uk-modal-container "  id="myModal" uk-modal="bg-close: false" style="">
        <div class="uk-modal-dialog  uk-modal-body uk-margin-auto-vertical"  style="background-color: #033860; color: white">
<!--          <button class="uk-modal-close-default" type="button" uk-close></button>-->
          <div class="uk-modal-header" >
            <h2 class="uk-modal-title">Cookie Policy</h2>
          </div>
          <div class="uk-modal-body">
            <p>
              We use cookies to assess the use, user friendliness and reliability of our websites. Cookies we
              use also allow us to improve the quality of the services we offer and to provide a personalized
              user experience for you. Please feel free to customize your cookie preferences or change your
              cookie settings at any time.
            </p>
            <p>
              Thank you for using our websites. Happy browsing.
            </p>
          </div>
          <div class="uk-modal-footer uk-text-right" >

<!--            <router-link to="/cookies" class="uk-button uk-text-bold uk-text-capitalize " style="margin: 5px; background-color: rgba(255, 215, 3,0.9); color: white; "
            id="info"
            > More Information
            </router-link>-->
<!--            <button class="uk-button uk-button-default" href="#modal-full" uk-toggle style="background-color: rgba(255, 215, 3,0.9); color: white"
            @click="makeModalTrue" >More Information</button>-->
            <a class="uk-button uk-button-default uk-text-bold" href="#modal-full"  style="background-color: #ffcb05; color: #033860; margin: 5px;" uk-toggle>More Information </a>

            <a class="uk-button uk-button-default uk-text-bold  uk-modal-close" type="button" id="accept" @click="makeModalTrue"
            style="background-color: #ffcb05; color: #033860">Yes, I Accept</a>
            <br>

<!--            <div class="uk-container-small uk-position-bottom-center uk-padding-small">
              <a href="/privacy" class="uk-padding-small" >Privacy Policy</a>
              <a href="/dataProtection" >Data Protection Policy</a>
            </div>-->

            <div id="modal-full" class="uk-modal-full" uk-modal>
              <div class="uk-modal-dialog">

<!--                <button class="uk-modal-close-full uk-close-large" type="button"  ></button>-->

                <div class="uk-padding-large" uk-height-viewport>
                  <ul class="uk-subnav uk-subnav-pill uk-flex-center" uk-switcher>
                    <li><a href="#">Cookie Policy</a></li>
                    <li><a href="#">Privacy Notice</a></li>
                    <li><a href="#">Data Protection Notice</a></li>
                  </ul>

                  <div class="uk-switcher uk-margin">
                    <div>
                      <CookieNotice />
                    </div>
                    <div>
                      <PrivacyNotice />
                    </div>
                    <div>
                      <DataProtectionNotice />
                    </div>
                  </div>
                  <div class="uk-text-center">
                    <a href="#" class="uk-button uk-button-primary uk-button-large uk-width-1-3@l uk-width-1-3@m uk-width-1-3@s uk-light" style="color: #F5F5F5 !important; font-size: 16px;"  @click="showModalAgain">I Understand</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

</div>
</template>

<style scoped>
.router-link-exact-active{
  color: #033860;

}

.uk-modal-footer, .uk-modal-header, .uk-modal-title{
  background-color: #033860;
  color: white;
}

/*a{
  color: goldenrod;
  font-weight: bolder;
}
a:hover{
  color: goldenrod;
}*/
</style>